import * as fromDatatype from '../datatype-library/index';

export interface app_mst_link_subject_to_device_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_subject_guid: fromDatatype.GuidDataFieldInterface;
  app_device_guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_mst_link_subject_to_device_RowClass implements app_mst_link_subject_to_device_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_subject_guid: fromDatatype.GuidDataFieldInterface;
  app_device_guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
